import { Card, Tooltip } from '@mui/material'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import InfoIcon from '@mui/icons-material/InfoOutlined'

interface Props {
  icon: React.ReactNode
  title: string
  values: any
  info?: string
}

export default function Kpi({ icon, title, values, info }: Props) {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
      <Card sx={{ p: 2, textAlign: 'center' }} elevation={0}>
        <Stack>
          <Grid container alignItems={'center'} justifyContent={'center'}>
            <Grid item>
              <Typography sx={{ mb: 1 }}>{title}</Typography>
            </Grid>
            {info && (
              <Grid item>
                <Tooltip title={info}>
                  <InfoIcon sx={{ fontSize: 16, ml: 0.5, mt: -2 }} />
                </Tooltip>
              </Grid>
            )}
          </Grid>

          <Grid container alignItems={'center'} justifyContent={'center'}>
            {icon}
            <Stack>
              {values.map((value: any, index: any) => (
                <Typography key={index} variant='h5'>
                  {value}
                </Typography>
              ))}
            </Stack>
          </Grid>
        </Stack>
      </Card>
    </Grid>
  )
}
